import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../generic-components/Button';
import Heading from '../../../generic-components/Heading';
import { STYLES } from '../consts';

interface IProps {
  activeTabId: string;
  onTabSelection: (id: string) => void;
}

export const FORM_TYPES = {
  BUSINESS: 'BUSINESS',
  INDI: 'INDIVIDUAL',
};

export const FormTypeSwitch = ({ activeTabId, onTabSelection }: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={STYLES.TAB_SWITCH_WRAPPER}>
      <div
        className={`move-left-switch absolute ${activeTabId === FORM_TYPES.BUSINESS ? 'left-[5px]' : 'left-[187px]'} w-[calc(50%-5px)] h-[calc(100%-5px)] bg-bw00 shadow-bottomShadow rounded-[8px]`}
      />
      <Button
        onClick={() => onTabSelection(FORM_TYPES.BUSINESS)}
        className='basis-1/2 py-[10px] z-[99999]'
        id={FORM_TYPES.BUSINESS}
        childElement={<Heading title={t('CREATE_SUPPLIER_FLOW.SWITCH_TABS.BUSINESS')} className={`${activeTabId === FORM_TYPES.BUSINESS ? 'text-action03' : 'text-bw07'}`} />}
      />
      <Button
        onClick={() => onTabSelection(FORM_TYPES.INDI)}
        className='basis-1/2 py-[10px] z-[99999]'
        id={FORM_TYPES.INDI}
        childElement={<Heading title={t('CREATE_SUPPLIER_FLOW.SWITCH_TABS.INDIVIDUAL')} className={`${activeTabId === FORM_TYPES.INDI ? 'text-action03' : 'text-bw07'}`} />}
      />
    </div>
  );
};
